import { FONT_PRESETS, HEADING_FONTS, BODY_FONTS } from './colorUtils'

// Applies theme fonts by setting CSS vars on .visitor-theme elements (not :root, so the
// admin UI keeps default fonts). No loading here: @font-face lives in public/fonts/fonts.css.

/**
 * Apply a font preset by key.
 * @param {string} presetKey — one of: classic | elegant | literary | modern | artisan | studio
 */
export function loadFontPreset(presetKey) {
  const preset = FONT_PRESETS[presetKey]
  if (!preset) return
  setFontVars(preset.decorative, preset.primary)
}

/**
 * Apply an arbitrary heading + body font pair from the custom font picker and
 * remember it for the next boot's synchronous font warm-up.
 * @param {string} headingName — display name, e.g. 'Playfair Display'
 * @param {string} bodyName    — display name, e.g. 'Nunito'
 */
export function loadFontPair(headingName, bodyName) {
  const headingDef = HEADING_FONTS.find(f => f.name === headingName)
  const bodyDef    = BODY_FONTS.find(f => f.name === bodyName)
  if (!headingDef || !bodyDef) return

  setFontVars(headingName, bodyName)

  try {
    localStorage.setItem('gv2_font_heading', headingName)
    localStorage.setItem('gv2_font_body', bodyName)
  } catch { /* localStorage unavailable */ }
}

function setFontVars(decorative, primary) {
  // '<Family> Fallback' = metric-matched local font from fonts.css: same layout
  // while the webfont downloads, so the swap doesn't reflow.
  const targets = document.querySelectorAll('.visitor-theme')
  targets.forEach(el => {
    el.style.setProperty('--font-decorative', `'${decorative}', '${decorative} Fallback', serif`)
    el.style.setProperty('--font-primary',    `'${primary}', '${primary} Fallback', sans-serif`)
  })
}
